<template>
	<div class="chooseCooPartner">
		<!-- 合作对象组件 -->
		<div class="fz-16 chooseCooPartner-title pl-8">选择合作对象</div>
		<div class="mt-24">
			<span class="redStar yx-color-pure-1 font-h4-regular mr-32"> <span class="color-r-4">*</span>合作对象 </span>
			<el-radio v-model="copartner" label="0" class="mr-32 radio-style">达人</el-radio>
			<el-radio :disabled="$isPlatOr(['Sp', 'Xhs', 'All'])" class="radio-style" v-if="!isTalent" v-model="copartner" label="1">
				团长
				<span v-if="$isPlatOr(['Sp', 'Xhs', 'All'])">(敬请期待)</span>
			</el-radio>
		</div>
		<div class="mt-12">
			<base-table :columns="columns" :list="list" class="partnerTable"></base-table>
		</div>
		<div class="footer pb-12 pl-16 pt-12" v-if="isBatch">
			<el-button type="text" @click="addTalent" v-if="isDr" :disabled="isAbled" :class="{ btnGray: isAbled }">+添加合作达人</el-button>
			<el-button type="text" @click="addTz" v-else :disabled="isAbled" :class="{ btnGray: isAbled }">+添加合作团长</el-button>
			<span class="yx-color-text-secondary ml-4 font-h4-regular">(已选 {{ selectedNum }}/{{ allNum }})</span>
		</div>
		<!-- 添加合作达人 -->
		<ChooseCooAnthorDrawer ref="CooAnthorDrawer" @getDrList="getDrList($event)" :platformId="platformId"></ChooseCooAnthorDrawer>
		<!-- 添加合作团长 -->
		<ChooseCooColonelDrawer ref="CooColonelDrawer" @getTzList="getTzList($event)" :platformId="platformId"></ChooseCooColonelDrawer>
	</div>
</template>
<script>
import { talentColumns, tzColumns } from './columns';
import ChooseCooColonelDrawer from '../chooseCooColonelDrawer';
import ChooseCooAnthorDrawer from '../chooseCooAnthorDrawer';
export default {
	name: 'ChooseCooPartner',
	data() {
		return {
			talentColumns, //达人配置项
			tzColumns, //团长配置项
			copartner: '0', //默认为达人
			drList: [], //达人列表
			tzList: [], //团长列表
			teamIdObj: {},
		};
	},
	components: {
		ChooseCooColonelDrawer,
		ChooseCooAnthorDrawer,
	},
	props: {
		platformId: {
			type: [Number, String],
			default: '',
		},
		chooseAnchorList: {
			type: Array,
			default: () => [],
		},
		isBatch: {
			type: Boolean,
			default: true,
		},
		isTalent: {
			type: Boolean,
			default: true,
		},
	},
	watch: {
		copartner(val) {
			this.tzList = [];
			this.drList = [];
			this.teamIdObj = {};
			this.$refs.CooAnthorDrawer.reset();
			this.$emit('gutCopartner', val);
		},
		chooseAnchorList: {
			immediate: true,
			deep: true,
			handler(val) {
				this.getDrList(val);
			},
		},
		drList: {
			handler: function (val) {
				let isChecked = false;
				if (val && val.length) {
					isChecked = val.every(item => item.isChecked);
				}
				let anchor_list = val?.map(item => {
					const { team_institution_id: contact_id, id: anchor_id } = item;
					return {
						contact_id,
						anchor_id,
					};
				});
				let obj = {
					anchor_list,
					isChecked,
				};
				this.$emit('getList', obj);
			},
			deep: true,
		},
		tzList: {
			handler: function (val) {
				let isChecked = false;
				if (val && val.length) {
					isChecked = true;
				}
				let anchor_list = val?.map(item => {
					item.anchor_id = item.anchor_id || '0';
					const { team_institution_id, anchor_id } = item;
					return {
						team_institution_id,
						anchor_id,
					};
				});
				let obj = {
					anchor_list,
					isChecked,
				};
				this.$emit('getList', obj);
			},
			deep: true,
		},
	},
	computed: {
		//选择合作达人列表配置还是团长列表配置
		columns() {
			return this.isDr ? this.talentColumns : this.tzColumns;
		},
		//判断是否是添加达人
		isDr() {
			return this.copartner === '0';
		},
		isTz() {
			return this.copartner === '1';
		},
		list() {
			return this.isDr ? this.drList : this.tzList;
		},
		//已选数量
		selectedNum() {
			return this.drList?.length || this.tzList?.length || 0;
		},
		//全部的数量
		allNum() {
			return this.isDr ? 20 : 20;
		},
		//按钮是否禁用
		isAbled() {
			return this.allNum == this.selectedNum;
		},
	},
	mounted() {
		this.$Bus.$on('drSelectChange', (val, rowId, nickName) => {
			this.drList.forEach(item => {
				if (item.id == rowId) {
					item.team_institution_id = val || '';
					this.teamIdObj[rowId] = val;
					item.nickName = nickName || '';
				}
			});
		});
		this.$Bus.$on('resetTzId', rowId => {
			this.teamIdObj[rowId] = '';
		});
		this.$Bus.$on('saveAddress', addressObj => {
			this.drList.find(v => v.team_institution_id == addressObj.tzId);
		});
	},
	beforeDestroy() {
		this.$Bus.$off('drSelectChange');
		this.$Bus.$off('resetTzId');
	},
	methods: {
		//渲染达人
		getDrList(params) {
			//获取id的数组
			let list = [];
			list = params.map(item => ({
				...item,
				operation: this.getButtons(item.id),
				isDr: true,
				team_institution_id: this.teamIdObj[item.id],
				isChecked: false,
				isGetAddress: false,
				platformId: this.platformId,
			}));
			this.drList = this.drList.concat(list);
		},
		//渲染团长列表
		getTzList(params) {
			const _params = params.map(item => ({
				...item,
				operation: this.getButtons(item.id),
				isTz: true,
				team_institution_id: item.team_institution_id || '',
				isChecked: false,
				anchor_id: '',
				platformId: this.platformId,
			}));
			this.tzList.push(..._params);
		},
		//添加合作达人
		addTalent() {
			this.$refs.CooAnthorDrawer.show(this.drList);
		},
		//添加团长
		addTz() {
			this.$refs.CooColonelDrawer.show(this.tzList);
		},
		//从列表中删除数据
		delet(id) {
			const { tzList, drList } = this;
			if (this.isDr) {
				this.drList = drList.filter(item => item.id !== id);
				this.drList.forEach(item => {
					item.isGetAddress = false;
				});
			} else {
				this.tzList = tzList.filter(item => item.id !== id);
			}
			this.teamIdObj[id] = '';
			this.$Bus.$emit('sendContactOptions', this.drList);
		},
		getButtons(id) {
			let arr = [];
			arr.push({
				label: '删除',
				type: 'text',
				classtype: 3,
				click: () => {
					this.delet(id);
				},
			});
			return arr;
		},
		//清空相关数据
		reset() {
			this.drList = [];
			this.tzList = [];
			this.teamIdObj = {};
			this.copartner = 0;
		},
	},
};
</script>
<style lang="less" scoped>
.el-button {
	color: @color-primary;
	font-size: 14px;
}
.footer {
	border-bottom: 1px solid #f0f1f5;
}
/deep/ .el-radio__inner {
	border: 1px solid #c9cdd4 !important;
}
.partnerTable /deep/.el-button {
	font-size: 12px !important;
}
.partnerTable {
	/deep/ .el-table__header-wrapper {
		border-radius: 4px 4px 0 0 !important;
	}
	/deep/ .el-table__header-wrapper tr {
		background: @color-gy3 !important;
	}
	/deep/ th.el-table__cell {
		background: none;
		padding: 8px 0 8px 0px !important;
	}
	/deep/ .el-table__header {
		width: 100% !important;
	}
	/deep/ .el-table__body {
		width: 100% !important;
	}
	/deep/ .cell {
		font-size: 14px !important;
		color: @color-regular !important;
		font-weight: normal !important;
	}
}
/deep/ .el-radio__label {
	padding-left: 8px;
}
.btnGray {
	color: #c9cdd4;
}
.chooseCooPartner-title {
	position: relative;
	color: @color-gy9;
	font-weight: 500;
}
.chooseCooPartner-title::before {
	content: '';
	width: 3px;
	height: 17px;
	background: @color-b4;
	border-radius: 20px;
	position: absolute;
	left: 0px;
	top: 50%;
	transform: translateY(-50%);
}
.radio-style {
	/deep/ .is-checked .el-radio__inner {
		border: none !important;
	}
}
</style>
